import { Injectable } from '@angular/core';
import { CheckoutActions, CheckoutApiService } from '@checkout/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class UserPickupShopsEffects {
  loadUserShopList$: Observable<
    CheckoutActions.LoadUserPickupShopListSuccess | CheckoutActions.LoadUserPickupShopListFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckoutActions.LOAD_USER_PICKUP_SHOP_LIST),
      switchMap(() =>
        this.checkoutApiService.loadUserShopList().pipe(
          map((shops) => new CheckoutActions.LoadUserPickupShopListSuccess(shops)),
          catchError((error) => of(new CheckoutActions.LoadUserPickupShopListFail(error))),
        ),
      ),
    ),
  );

  addUserShop$: Observable<
    | CheckoutActions.AddUserPickupShopSuccess
    | CheckoutActions.AddUserPickupShopFail
    | CheckoutActions.LoadUserPickupShopListSuccess
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckoutActions.ADD_USER_PICKUP_SHOP),
      map((action: CheckoutActions.AddUserPickupShop) => action.payload),
      switchMap(({ shopName }: { shopName: string }) =>
        this.checkoutApiService.addUserShop(shopName).pipe(
          switchMap((shops) =>
            from([
              new CheckoutActions.AddUserPickupShopSuccess({ shopName }),
              new CheckoutActions.LoadUserPickupShopListSuccess(shops),
            ]),
          ),
          catchError((error) => of(new CheckoutActions.AddUserPickupShopFail({ shopName, error }))),
        ),
      ),
    ),
  );

  removeUserShop$: Observable<
    | CheckoutActions.RemoveUserPickupShopSuccess
    | CheckoutActions.RemoveUserPickupShopFail
    | CheckoutActions.LoadUserPickupShopListSuccess
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckoutActions.REMOVE_USER_PICKUP_SHOP),
      map((action: CheckoutActions.RemoveUserPickupShop) => action.payload),
      switchMap(({ shopName }: { shopName: string }) =>
        this.checkoutApiService.removeUserShop(shopName).pipe(
          switchMap((shops) =>
            from([
              new CheckoutActions.RemoveUserPickupShopSuccess({ shopName }),
              new CheckoutActions.LoadUserPickupShopListSuccess(shops),
            ]),
          ),
          catchError((error) => of(new CheckoutActions.RemoveUserPickupShopFail({ shopName, error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private checkoutApiService: CheckoutApiService,
  ) {}
}
